// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_ps-8";
export var editMode = "_ps-3";
export var headerRow = "_ps-a";
export var headerTitle = "_ps-b";
export var product = "_ps-1";
export var productDetails = "_ps-5";
export var productDivider = "_ps-7";
export var productImage = "_ps-2";
export var productInfo = "_ps-4";
export var productTitle = "_ps-6";
export var strikethrough = "_ps-9";
export var upsellProductsCard = "_ps-0";